export const UNSAVED_CHANGES_MESSAGE =
  'Você possui alterações não salvas. Deseja sair e descartá-las?';

export function hasFormChanged(initialValue, currentValue) {
  return JSON.stringify(initialValue ?? null) !== JSON.stringify(currentValue ?? null);
}

export function confirmDiscardChanges(isDirty) {
  return !isDirty || window.confirm(UNSAVED_CHANGES_MESSAGE);
}
